export type SexualHealthApplicabilityContext = {
  userGender: "male" | "female" | null;
  partnerGender: "male" | "female" | null;
  partnerChoice: "solo" | "with-partner" | "using-donor" | "unsure" | null;
  treatmentGoal: string | null;
};

/**
 * Sperm-exposure questions belong only to a conception pathway with an
 * opposite-sex partner. Missing context intentionally excludes the question.
 */
export function isHeterosexualConceptionContext(
  state: SexualHealthApplicabilityContext,
): boolean {
  if (
    state.treatmentGoal !== "pregnancy" ||
    state.partnerChoice !== "with-partner"
  ) {
    return false;
  }

  return (
    (state.userGender === "female" && state.partnerGender === "male") ||
    (state.userGender === "male" && state.partnerGender === "female")
  );
}

export const SEXUAL_HEALTH_QUESTION_APPLICABILITY = {
  Lubricants: {
    condition: "pregnancy + with-partner + opposite-sex partner",
  },
  PartnerEjaculate: {
    condition: "pregnancy + with-partner + opposite-sex partner",
    wording: "rephrase for patient sex",
  },
} as const;
